import { render } from "./InputCapacity.vue?vue&type=template&id=4d591f42"
import script from "./InputCapacity.vue?vue&type=script&lang=js"
export * from "./InputCapacity.vue?vue&type=script&lang=js"
script.render = render

export default script